module.exports = __webpack_public_path__ + "img/anna-dickinson.1cf62c38.png";